<template>
  <div>
    <div class="weather">
      <div class="temperature">{{ weather.temperature }}°C</div>
      <div class="type">{{ weather.type }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['weather']),
  },
};
</script>

<style scoped>
.temperature {
  text-align: center;
  font-weight: bold;
  font-size: 56pt;
  margin-bottom: 2%;
}
.type {
  text-align: center;
  font-size: 26pt;
}
</style>
